import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-uppercase" }

import { PropType, ref, computed } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownSelectButton',
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    options: {
      type: Array as PropType<{ name: string, value: string, icon: string }[]>,
      default: null
    },
    colour: {
      type: String,
      default: "white"
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { emit: __emit }) {

  const props = __props

  const selectedOption = computed(() => props.options.find(o => o.value === value.value))

  const value = computed<string>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return ""
      }
    },
    set(value: string) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    color: __props.colour,
    flat: "",
    dense: "",
    icon: selectedOption.value!.icon,
    class: "text-weight-bold brand-button",
    label: selectedOption.value!.name
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: option.name+index,
              clickable: "",
              dense: "",
              class: _normalizeClass([value.value === option.value ? 'text-white bg-primary' : 'text-primary', "text-weight-bold brand-button"]),
              onClick: ($event: any) => (value.value = option.value)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      color: value.value===option.value ? 'white' : 'primary',
                      name: option.icon
                    }, null, 8, ["color", "name"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(option.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class", "onClick"])), [
              [_directive_close_popup]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["color", "icon", "label"]))
}
}

})